/**
 * Enlace profundo "?accion=<clave>" para pantallas con tarjetas de acción.
 *
 * El buscador global (Ctrl+K) navega a rutas como
 * /facturacion/ventas?accion=credito; la pantalla declara sus claves con este
 * hook y el diálogo correspondiente se abre solo. El parámetro se limpia al
 * abrir (replace, no ensucia el historial) para que cerrar el diálogo no lo
 * reabra. Si el permiso aún no está cargado (rehidratación de sesión), el
 * parámetro se conserva y se reintenta en el siguiente render.
 *
 *   useAccionInicial({
 *     credito: { permitido: puedeCredito, abrir: () => setCreditoOpen(true) },
 *     contado: { permitido: puedeContado, abrir: () => setContadoOpen(true) },
 *   });
 */
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function useAccionInicial(acciones) {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const clave = searchParams.get("accion");
    if (!clave) return;
    const entrada = acciones[clave];
    if (!entrada || entrada.permitido === false) return;
    entrada.abrir();
    setSearchParams({}, { replace: true });
  });
}
